



export const SidebarData1 = [

  {
    tittle: 'Main Menu',
    hasSubRoute: true,
    icon: 'layout-grid',
    showSubRoute: false,
    subRoutes: [
      {
        tittle: 'Dashboard',
        hasSubRoute: true,
        showSubRoute: true,
        subRoutes: [
          {
            tittle: 'Admin Dashboard',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/index",
            subRoutes: [],
          },
          {
            tittle: 'Admin Dashboard 2',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/admin-dashboard",
            subRoutes: [],
          },
          {
            tittle: 'Sales Dashboard',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/sales-dashboard",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Super Admin',
        hasSubRoute: true,
        showSubRoute: true,
        subRoutes: [
          {
            tittle: 'Dashboard',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/dashboard",
            subRoutes: [],
          },
          {
            tittle: 'Companies',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/companies",
            subRoutes: [],
          },
          {
            tittle: 'Subscriptions',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/subscription",
            subRoutes: [],
          },
          {
            tittle: 'Packages',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/packages",
            subRoutes: [],
          },
          {
            tittle: 'Domain',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/domain",
            subRoutes: [],
          },
          {
            tittle: 'Purchase Transaction',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/purchase-transaction",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Application',
        hasSubRoute: true,
        showSubRoute: true,
        base: 'application',
        subRoutes: [
          {
            tittle: 'Chat',
            route: "/chat",
            hasSubRoute: false,
            showSubRoute: false,
            customSubmenuTwo: false,
          },
          {
            tittle: 'Call',
            hasSubRoute: true,
            showSubRoute: true,
            base: 'application',
            subRoutes: [
              {
                tittle: 'Video Call',
                route: "/video-call",
                hasSubRoute: false,
                showSubRoute: false,
                subRoutes: [],
              },
              {
                tittle: 'Audio Call',
                route: "/audio-call",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Call History',
                route: "/call-history",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Calendar',
            route: "/calendar",
            hasSubRoute: false,
            showSubRoute: false,
            customSubmenuTwo: false,
          },
          {
            tittle: 'Email',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/email",
            customSubmenuTwo: false,
            subRoutes: [],
          },
          {
            tittle: 'To Do',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/todo",
            customSubmenuTwo: false,
            subRoutes: [],
          },
          {
            tittle: 'Notes',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/notes",
            customSubmenuTwo: false,
            subRoutes: [],
          },
          {
            tittle: 'File Manager',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/file-manager",
            customSubmenuTwo: false,
            subRoutes: [],
          },
          {
            tittle: 'Projects',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/projects",
            customSubmenuTwo: false,
            subRoutes: [],
          },
          {
            tittle: 'Ecommerce',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Services',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/products",
                subRoutes: [],
              },
              {
                tittle: 'Orders',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/orders",
                subRoutes: [],
              },
              {
                tittle: 'Customers',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/customers",
                subRoutes: [],
              },
              {
                tittle: 'Cart',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/cart",
                subRoutes: [],
              },
              {
                tittle: 'Checkout',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/checkout",
                subRoutes: [],
              },
              {
                tittle: 'Wishlist',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/wishlist",
                subRoutes: [],
              },
              {
                tittle: 'Reviews',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/reviews",
                subRoutes: [],
              },
            ],
          },
          {
            tittle: 'Social Feed',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/social-feed",
            subRoutes: [],
          },
          {
            tittle: 'Search List',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/search-list",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Layouts',
        hasSubRoute: true,
        icon: 'layout-sidebar-right-collapse',
        showSubRoute: false,
        subRoutes: [
          {
            tittle: 'Horizontal',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-horizontal",
            subRoutes: [],
          },
          {
            tittle: 'Detached',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-detached",
            subRoutes: [],
          },
          {
            tittle: 'Modern',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-modern",
            subRoutes: [],
          },
          {
            tittle: 'Two Column',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-two-column",
            subRoutes: [],
          },
          {
            tittle: 'Hovered',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-hovered",
            subRoutes: [],
          },
          {
            tittle: 'Boxed',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-boxed",
            subRoutes: [],
          },
          {
            tittle: 'RTL',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-rtl",
            subRoutes: [],
          },
          {
            tittle: 'Dark',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/layout-dark",
            subRoutes: [],
          },
    
        ],
      },
    ],
  },
  
  {
    tittle: 'Inventory',
    hasSubRoute: true,
    icon: 'brand-unity',
    showSubRoute: false,
    activeRoute: 'product',
    subRoutes: [
      {
        tittle: 'Products',
        hasSubRoute: false,
        showSubRoute: true,
        route: "/product-list",
        subRoutes: [],
      },
      {
        tittle: 'Create Product',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/add-product",
        subRoutes: [],
      },
      {
        tittle: 'Expired Products',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/expired-products",
        subRoutes: [],
      },
      {
        tittle: 'Low Stocks',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/low-stocks",
        subRoutes: [],
      },
      {
        tittle: 'Category',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/category-list",
        subRoutes: [],
      },
      {
        tittle: 'Sub Category',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/sub-categories",
        subRoutes: [],
      },
      {
        tittle: 'Brands',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/brand-list",
        subRoutes: [],
      },
      {
        tittle: 'Units',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/units",
        subRoutes: [],
      },
      {
        tittle: 'Variant Attributes',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/variant-attributes",
        subRoutes: [],
      },
      {
        tittle: 'Warranties',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/warranty",
        subRoutes: [],
      },
      {
        tittle: 'Print Barcode',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/barcode",
        subRoutes: [],
      },
      {
        tittle: 'Print QR Code',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/qrcode",
        subRoutes: [],
      },
    ],
  },
  {
    tittle: 'Sales & Purchase',
    hasSubRoute: true,
    icon: 'layout-grid',
    showSubRoute: false,
    activeRoute: 'users',
    subRoutes: [
      {
        tittle: 'Stock',
        hasSubRoute: true,
        showSubRoute: false,
        subRoutes: [
          {
            tittle: 'Manage Stock',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/manage-stocks",
            subRoutes: [],
          },
          {
            tittle: 'Stock Adjustment',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/stock-adjustment",
            subRoutes: [],
          },
          {
            tittle: 'Stock Transfer',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/stock-transfer",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Sales',
        hasSubRoute: true,
        showSubRoute: false,
        route: "/sales-list",
        subRoutes: [
          {
            tittle: 'Sales',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Online Orders',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/online-orders",
                subRoutes: [],
              },
              {
                tittle: 'POS Orders',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos-orders",
                subRoutes: [],
              },
            ],
          },
          {
            tittle: 'Invoice',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/invoice-settings",
            subRoutes: [],
          },
          {
            tittle: 'Sales Return',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/sales-returns",
            subRoutes: [],
          },
          {
            tittle: 'Quotation',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/quotation-list",
            subRoutes: [],
          },
          {
            tittle: 'POS',
            hasSubRoute: true,
            showSubRoute: true,
            route: "/pos",
            subRoutes: [
              {
                tittle: 'POS 1',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos",
                subRoutes: [],
              },
              {
                tittle: 'POS 2',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos-2",
                subRoutes: [],
              },
              {
                tittle: 'POS 3',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos-3",
                subRoutes: [],
              },
              {
                tittle: 'POS 4',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos-4",
                subRoutes: [],
              },
              {
                tittle: 'POS 5',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/pos-5",
                subRoutes: [],
              },
            ],
          },
        ],
      },
      {
        tittle: 'Promo',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'promo',
        subRoutes: [
          {
            tittle: 'Coupons',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/coupons",
            subRoutes: [],
          },
          {
            tittle: 'Gift Cards',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/gift-cards",
            subRoutes: [],
          },
          {
            tittle: 'Discount',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Discount Plan',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/discount-plan",
                subRoutes: [],
              },
              {
                tittle: 'Discount',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/discount",
                subRoutes: [],
              },
            ],
          },
        ],
      },
      {
        tittle: 'Purchases',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Purchases',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/purchase-list",
            subRoutes: [],
          },
          {
            tittle: 'Purchase Order',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/purchase-order-report",
            subRoutes: [],
          },
          {
            tittle: 'Purchase Return',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/purchase-returns",
            subRoutes: [],
          },
          {
            tittle: 'Expenses',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Expenses',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/expense-list",
                subRoutes: [],
              },
              {
                tittle: 'Expense Category',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/expense-category",
                subRoutes: [],
              },
            ],
          },

        ],
      },
      {
        tittle: 'Expenses',
        hasSubRoute: true,
        showSubRoute: true,
        //   route: routes.stockTransfer,
        subRoutes: [
          {
            tittle: 'Expenses',
            route: "/expense-list",
          },
          {
            tittle: 'Expense Category',
            route: "/expense-category",
          },
        ],
      },
      {
        tittle: 'Income',
        hasSubRoute: true,
        showSubRoute: false,
        route: "/purchase-returns",
        subRoutes: [
          {
            tittle: 'Income',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/income",
            subRoutes: [],
          },
          {
            tittle: 'Income Category',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/income-category",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Bank Accounts',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/account-list",
        subRoutes: [],
      },
      {
        tittle: 'Money Transfer',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/money-transfer",
        subRoutes: [],
      },
      {
        tittle: 'Balance Sheet',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/balance-sheet",
        subRoutes: [],
      },
      {
        tittle: 'Trial Balance',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/trial-balance",
        subRoutes: [],
      },
      {
        tittle: 'Cash Flow',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/cash-flow",
        subRoutes: [],
      },
      {
        tittle: 'Account Statement',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/account-statement",
        subRoutes: [],
      },
    ],
  },
  {
    tittle: 'UI Interface',
    hasSubRoute: true,
    icon: 'users-group',
    showSubRoute: false,
    activeRoute: 'users',
    subRoutes: [
      
      {
        tittle: 'Base UI',
        hasSubRoute: true,
        icon: 'assets/img/icons/printer.svg',
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Alerts',
            route: "/ui-alerts",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Accordion',
            route: "/ui-accordion",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Avatar',
            route: "/ui-avatar",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Badges',
            route: "/ui-badges",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Border',
            route: "/ui-borders",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Buttons',
            route: "/ui-buttons",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Button Group',
            route: "/ui-buttons-group",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Breadcrumb',
            route: "/ui-breadcrumb",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Card',
            route: "/ui-cards",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Carousel',
            route: "/ui-carousel",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Colors',
            route: "/ui-colors",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Dropdowns',
            route: "/ui-dropdowns",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Grid',
            route: "/ui-grid",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Images',
            route: "/ui-images",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Lightbox',
            route: "/ui-lightbox",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Media',
            route: "/ui-media",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Modals',
            route: "/ui-modals",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Offcanvas',
            route: "/ui-offcanvas",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Pagination',
            route: "/ui-pagination",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Popovers',
            route: "/ui-popovers",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Progress',
            route: "/ui-progress",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Placeholders',
            route: "/ui-placeholders",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Range Slider',
            route: "/ui-rangeslider",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Spinner',
            route: "/ui-spinner",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Sweet Alerts',
            route: "/ui-sweetalerts",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Tabs',
            route: "/ui-nav-tabs",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Toasts',
            route: "/ui-toasts",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Tooltips',
            route: "/ui-tooltips",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Typography',
            route: "/ui-typography",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Video',
            route: "/ui-video",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Sortable',
            route: "/ui-sortable",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Swiperjs',
            route: "/ui-swiperjs",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Advanced UI',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Ribbon',
            route: "/ui-ribbon",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Clipboard',
            route: "/ui-clipboard",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Drag & Drop',
            route: "/ui-drag-drop",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Rating',
            route: "/ui-rating",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Text Editor',
            route: "/ui-text-editor",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Counter',
            route: "/ui-counter",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Scrollbar',
            route: "/ui-scrollbar",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Sticky Note',
            route: "/ui-stickynote",
            hasSubRoute: false,
            showSubRoute: false,
          },

          {
            tittle: 'Timeline',
            route: "/ui-timeline",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Charts',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Apex Charts',
            route: "/chart-apex",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Chart Js',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/chart-js",
            subRoutes: [],
          },

        ],
      },
      {
        tittle: 'Icons',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Fontawesome Icons',
            route: "/icon-fontawesome",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Feather Icons',
            route: "/icon-feather",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Ionic Icons',
            route: "/icon-ionic",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Material Icons',
            route: "/icon-material",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Pe7 Icons',
            route: "/icon-pe7",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Simpleline Icons',
            route: "/icon-simpleline",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Themify Icons',
            route: "/icon-themify",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Weather Icons',
            route: "/icon-weather",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Typicon Icons',
            route: "/icon-typicon",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Flag Icons',
            route: "/icon-flag",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Tabler Icons',
            route: "/icon-tabler",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Bootstrap Icons',
            route: "/icon-bootstrap",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Remix Icons',
            route: "/icon-remix",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Forms',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Form Elements',
            hasSubRoute: false,
            showSubRoute: false,
            subRoutes: [
              {
                tittle: 'Basic Inputs',
                route: "/form-basic-inputs",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Checkbox & Radios',
                route: "/form-checkbox-radios",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Input Groups',
                route: "/form-input-groups",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Form Select',
                route: "/form-select",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Input Masks',
                route: "/form-mask",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'File Uploads',
                route: "/form-fileupload",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Layouts',
            hasSubRoute: false,
            showSubRoute: false,
            subRoutes: [
              {
                tittle: 'Horizontal Form',
                route: "/form-horizontal",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Vertical Form',
                route: "/form-vertical",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Floating Labels',
                route: "/form-floating-labels",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Form Validation',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/form-validation",
            subRoutes: [],
          },
          {
            tittle: 'Select2',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/form-select2",
            subRoutes: [],
          },
          {
            tittle: 'Form Wizard',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/form-wizard",
            subRoutes: [],
          },
          {
            tittle: 'Form Picker',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/form-pickers",
            subRoutes: [],
          },
          {
            tittle: 'Tables',
            hasSubRoute: false,
            showSubRoute: false,
            subRoutes: [
              {
                tittle: 'Basic Tables ',
                route: "/tables-basic",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Data Table',
                route: "/data-tables",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Maps',
            hasSubRoute: false,
            showSubRoute: false,
            subRoutes: [
              {
                tittle: 'Vector',
                route: "/maps-vector",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Leaflet',
                route: "/maps-leaflet",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    tittle: 'Profile',
    hasSubRoute: true,
    icon: 'user-circle',
    showSubRoute: false,
    subRoutes: [
      {
        tittle: 'Profile',
        route: "/profile",
        hasSubRoute: false,
        showSubRoute: false,
      },
      {
        tittle: 'Authentication',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: 'Login',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/signin",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/signin",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Register',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/register",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/signin",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Forgot Password',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/forgot-password",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/forgot-password",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Reset Password',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/reset-password",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/signin",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: 'Email Verification',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/email-verification",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/signin",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
          {
            tittle: '2 Step Verification',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/two-step-verification",
            subRoutes: [
              {
                tittle: 'Cover',
                route: "/signin",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Illustration',
                route: "/signin-2",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Basic',
                route: "/signin-3",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ],
          },
        ],
      },
      {
        tittle: 'Error',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: '404 Error',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/error-404",
            subRoutes: [],
          },
          {
            tittle: '500 Error',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/error-500",
            subRoutes: [],
          },

        ],
      },
      {
        tittle: 'Blank page',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/blank-page",
        subRoutes: [],
      },
      {
        tittle: 'Pricing',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/pricing",
        subRoutes: [],
      },
      {
        tittle: 'Comming Soon',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/coming-soon",
        subRoutes: [],
      },
      {
        tittle: 'Under Maintenance',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/under-maintenance",
        subRoutes: [],
      },
      {
        tittle: 'Content',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: 'Pages',
            hasSubRoute: true,
            showSubRoute: true,
            // route:"/employees-grid",
            subRoutes: [
              {
                tittle: 'Pages',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/pages",
                subRoutes: [],
              }
            ],
          },
          {
            tittle: 'Blog',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'All Blog',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/all-blog",
                subRoutes: [],
              },
              {
                tittle: 'Blog Tags',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/blog-tag",
                subRoutes: [],
              },
              {
                tittle: 'Categories',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/blog-categories",
                subRoutes: [],
              },
              {
                tittle: 'Blog Comments',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/blog-comments",
                subRoutes: [],
              },
            ],
          },
          {
            tittle: 'Location',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Countries',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/countries",
                subRoutes: [],
              },
              {
                tittle: 'States',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/states",
                subRoutes: [],
              },
              {
                tittle: 'Cities',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/cities",
                subRoutes: [],
              },
              {
                tittle: 'Testimonials',
                hasSubRoute: true,
                showSubRoute: true,
                route: "/testimonials",
                subRoutes: [],
              },
            ],
          },
          {
            tittle: 'FAQ',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/faq",
            subRoutes: [],
          },

        ],
      },
      {
        tittle: 'Employees',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: 'Employees',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/employees-grid",
            subRoutes: [],
          },
          {
            tittle: 'Designations',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/designation",
            subRoutes: [],
          },
          {
            tittle: 'Departments',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/department-grid",
            subRoutes: [],
          },
          {
            tittle: 'Shifts',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/shift",
            subRoutes: [],
          }

        ],
      },
      {
        tittle: 'Attendance',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: 'Employee Attendance',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/attendance-employee",
            subRoutes: [],
          },
          {
            tittle: 'Admin Attendance',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/attendance-admin",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'Leave & Holidays',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.purchaseReport,
        subRoutes: [
          {
            tittle: 'Admin Leaves',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/leaves-admin",
            subRoutes: [],
          },
          {
            tittle: 'Employee Leaves',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/leaves-employee",
            subRoutes: [],
          },
          {
            tittle: 'Leave Types',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/leave-types",
            subRoutes: [],
          },
          {
            tittle: 'Holidays',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/holidays",
            subRoutes: [],
          },
          {
            tittle: 'Payroll',
            hasSubRoute: true,
            showSubRoute: true,
            route: "/employee-salary",
            subRoutes: [
              {
                tittle: 'Employee Salary',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/employee-salary",
                subRoutes: [],
              },
              {
                tittle: 'Payslip',
                hasSubRoute: false,
                showSubRoute: false,
                route: "/payslip",
                subRoutes: [],
              }
            ],
          },
        ],
      },
    ],
  },
  {
    tittle: 'Reports',
    hasSubRoute: true,
    icon: 'chart-bar',
    showSubRoute: false,
    activeRoute: 'users',
    subRoutes: [
      {
        tittle: 'Sales Report',
        hasSubRoute: true,
        showSubRoute: true,
        subRoutes: [
          {
            tittle: 'Sales Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/sales-report",
          },
          {
            tittle: 'Best Seller',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/best-seller",
          },
        ],
      },
      {
        tittle: 'Purchase Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/purchase-report",
        subRoutes: [],
      },
      {
        tittle: 'Inventory Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/inventory-report",
        subRoutes: [
          {
            tittle: 'Inventory Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/inventory-report",
            subRoutes: []
          },
          {
            tittle: 'Stock History',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/stock-history",
            subRoutes: []
          },
          {
            tittle: 'Sold Stock',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/sold-stock",
            subRoutes: []
          },
        ],
      },
      {
        tittle: 'Invoice Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/invoice-report",
        subRoutes: [],
      },
      {
        tittle: 'Supplier Report',
        hasSubRoute: true,
        showSubRoute: true,
        subRoutes: [
          {
            tittle: 'Supplier Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/supplier-report",
            subRoutes: []
          },
          {
            tittle: 'Supplier Due Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/supplier-due-report",
            subRoutes: []
          },
        ],
      },

      {
        tittle: 'Customer Report',
        hasSubRoute: false,
        showSubRoute: false,
        subRoutes: [
          {
            tittle: 'Customer Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/customer-report",
            subRoutes: []
          },
          {
            tittle: 'Customer Due Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/customer-due-report",
            subRoutes: []
          },
        ],
      },
      {
        tittle: 'Product Report',
        hasSubRoute: false,
        showSubRoute: false,
        subRoutes: [
          {
            tittle: 'Product Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/product-report",
            subRoutes: []
          },
          {
            tittle: 'Product Expiry Report',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/product-expiry-report",
            subRoutes: []
          },
          {
            tittle: 'Product Quantity Alert',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/product-quantity-alert",
            subRoutes: []
          },
        ],
      },
      {
        tittle: 'Expense Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/expense-report",
        subRoutes: [],
      },
      {
        tittle: 'Income Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/income-report",
        subRoutes: [],
      },
      {
        tittle: 'Tax Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/tax-report",
        subRoutes: [],
      },
      {
        tittle: 'Profit & Loss',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/profit-and-loss",
        subRoutes: [],
      },
      {
        tittle: 'Annual Report',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/annual-report",
        subRoutes: [],
      },
    ],
  },
  {
    tittle: 'Settings',
    hasSubRoute: true,
    icon: 'settings',
    showSubRoute: false,
    activeRoute: 'users',
    subRoutes: [
      {
        tittle: 'General Settings',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.users,
        subRoutes: [
          {
            tittle: 'Profile',
            route: "/profile",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Security',
            route: "/security-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Notifications',
            route: "/notification",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Connected Apps',
            route: "/connected-apps",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Website Settings',
        hasSubRoute: true,
        showSubRoute: false,
        subRoutes: [
          {
            tittle: 'System Settings',
            route: "/system-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Company Settings',
            route: "/company-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Localization',
            route: "/localization-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Prefixes',
            route: "/prefixes",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Preference',
            route: "/preference",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Appearance',
            route: "/appearance",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Social Authentication',
            route: "/social-authentication",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Language',
            route: "/language-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },

      {
        tittle: 'App Settings',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Invoice',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Invoice Settings',
                route: "/invoice-settings",
                hasSubRoute: true,
                showSubRoute: true,
                subRoutes: [],
              },
              {
                tittle: 'Invoice Template',
                route: "/invoice-template",
                hasSubRoute: true,
                showSubRoute: true,
                subRoutes: [],
              },
            ],
          },
          {
            tittle: 'Printer',
            route: "/printer-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'POS',
            route: "/pos-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Custom Fields',
            route: "/custom-fields",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'System Settings',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Email',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'Email Settings',
                route: "/email-settings",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'Email Template',
                route: "/email-template",
                hasSubRoute: false,
                showSubRoute: false,
              },

            ],
          },
          {
            tittle: 'SMS',
            hasSubRoute: true,
            showSubRoute: true,
            subRoutes: [
              {
                tittle: 'SMS Settings',
                route: "/sms-settings",
                hasSubRoute: false,
                showSubRoute: false,
              },
              {
                tittle: 'SMS Template',
                route: "/sms-template",
                hasSubRoute: false,
                showSubRoute: false,
              },
            ]
          },
          {
            tittle: 'OTP',
            route: "/otp-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'GDPR Cookies',
            route: "/gdpr-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Financial Settings',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Payment Gateway',
            route: "/payment-gateway-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Bank Accounts',
            route: "/bank-settings-grid",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Tax Rates',
            route: "/tax-rates",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Currencies',
            route: "/currency-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Other Settings',
        hasSubRoute: true,
        showSubRoute: false,
        activeRoute: 'users',
        subRoutes: [
          {
            tittle: 'Storage',
            route: "/storage-settings",
            hasSubRoute: false,
            showSubRoute: false,
          },
          {
            tittle: 'Ban IP Address',
            route: "/ban-ip-address",
            hasSubRoute: false,
            showSubRoute: false,
          },
        ],
      },
      {
        tittle: 'Logout',
        hasSubRoute: false,
        showSubRoute: false,
        route: "/signin",
      },
      
    ],
  },
  {
    tittle: 'More',
    hasSubRoute: true,
    icon: 'circle-plus',
    showSubRoute: false,
    activeRoute: 'More',
    subRoutes: [

      {
        tittle: 'People',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.users,
        subRoutes: [
          {
            tittle: 'Customers',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/customers",
            subRoutes: [],
          },
          {
            tittle: 'Billers',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/billers",
            subRoutes: [],
          },
          {
            tittle: 'Suppliers',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/suppliers",
            subRoutes: [],
          },
          {
            tittle: 'Stores',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/store-list",
            subRoutes: [],
          },
          {
            tittle: 'Franchises',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/franchise-list",
            subRoutes: [],
          },
          {
            tittle: 'Warehouses',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/warehouse",
            subRoutes: [],
          },
        ],
      },
      {
        tittle: 'User Management',
        hasSubRoute: true,
        showSubRoute: false,
        //   route: routes.users,
        subRoutes: [
          {
            tittle: 'Roles & Permissions',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/roles-permissions",
            subRoutes: [],
          },
          {
            tittle: 'Delete Account Request',
            hasSubRoute: false,
            showSubRoute: false,
            route: "/delete-account",
            subRoutes: [],
          },
        ],
      },
     
      {
        tittle: 'Documentation',
        hasSubRoute: false,
        showSubRoute: false,
        activeRoute: 'users',
      },
      {
        tittle: 'Changelog v2.0.7',
        hasSubRoute: false,
        showSubRoute: false,
        activeRoute: 'users',
      },
    ],
  },

];
